import { RootState } from "../root/redux.types";

export const selectNavigation = (state: RootState) => state.navigation;

export const selectMobileMessage = (state: RootState) =>
  state.navigation.mobileMessage;

export const selectCurrentFlowAction = (state: RootState) =>
  state.navigation.currentFlowAction;
